import {LoginLogProvider, useLoginLog} from "../contexts/LogonContext";
import {Container} from "../components/common";
import {CBBody, CBHeader, ContentBox} from "../components/common/ContentBox";
import PersonalIcon from "../../images/icon_personal.png";
import TableRecords from "../components/common/TableRecords";
import {useWindowScroll, useWindowSize} from "react-use";
import {useEffect} from "react";

const HeaderNames = ['Login time', 'Browser', 'OS', 'IP address', 'District', 'Application'];

const toDisplayTime = (time) => {
	const date = new Date(Date.parse(time));

	let hours = date.getHours();
	let minutes = date.getMinutes();

	const ampm = hours >= 12 ? 'PM' : 'AM';
	hours = hours % 12;
	hours = hours ? hours : 12;
	minutes = minutes < 10 ? '0'+minutes : minutes;

	return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${hours}:${minutes} ${ampm}`
}

const PreviousLoginView = () => {
	const {y} = useWindowScroll();
	const {height} = useWindowSize();
	const {data, hasMore, getNext, isFetching, refresh} = useLoginLog();

	const isFetchNew = y > 0 && y + height > document.body.clientHeight - 50 && hasMore && !isFetching;

	useEffect(() => () => refresh(), [refresh]);

	useEffect(() => isFetchNew ? getNext() : null, [isFetchNew, getNext]);

	const logs = data?.logs;

	new Date().toDateString()

	return (
		<Container>
			<h1>Previous Login</h1>

			<ContentBox>
				<CBHeader icon={PersonalIcon} title={'Previous Login'} />
				<CBBody>
					<TableRecords
						header={HeaderNames}
						records={logs}
						itemRenderer={(log) => (
							<>
								<td>{toDisplayTime(log.time)}</td>
								<td>{log.browser}</td>
								<td>{log.os}</td>
								<td>{log.ip}</td>
								<td>{log.district}</td>
								<td>{log.application}</td>
							</>
						)}
						isLoading={isFetching}
					/>
				</CBBody>
			</ContentBox>
		</Container>
	);
}

const WrappedPreviousLoginView =(props) => (
	<LoginLogProvider>
		<PreviousLoginView {...props}/>
	</LoginLogProvider>
);

export default WrappedPreviousLoginView;
